import { useMemo } from 'react';
import { PerformanceMobileTile } from 'src/components/SponsoredListings/PerformanceChart/PerformanceMobileTile';
import {
  AdCampaignsDataContextProvider,
  useAdCampaignsDataContext,
} from 'src/contexts/AdCampaignsDataContext/AdCampaignsDataContext';
import {
  DateRangePresetName,
  getUiDateTimeRangeFromPreset,
  StandardDateRangePresetNames,
} from 'src/utils/dateTimeUtils';
import { DateTimeRange } from 'src/WebApiController';

import { DashboardSectionWrapper } from '../DashboardSectionWrapper';

const useLast30DaysRange = (): DateTimeRange | null => {
  return useMemo(
    () =>
      getUiDateTimeRangeFromPreset(
        DateRangePresetName.Last30Days,
        StandardDateRangePresetNames
      ) ?? null,
    []
  );
};

const SponsoredRevenueHomeWidgetInner = ({
  dateRange,
}: {
  dateRange: DateTimeRange | null;
}) => {
  const { allCampaignData } = useAdCampaignsDataContext();

  const allCampaigns = useMemo(
    () => (allCampaignData ? Object.values(allCampaignData).flat() : null),
    [allCampaignData]
  );

  return (
    <PerformanceMobileTile
      allCampaigns={allCampaigns}
      dateRangeFilter={dateRange}
    />
  );
};

export const SponsoredRevenueHomeWidget = () => {
  const last30Days = useLast30DaysRange();

  return (
    <DashboardSectionWrapper>
      <AdCampaignsDataContextProvider fetchAllCampaigns dateRange={last30Days}>
        <SponsoredRevenueHomeWidgetInner dateRange={last30Days} />
      </AdCampaignsDataContextProvider>
    </DashboardSectionWrapper>
  );
};
